const CSRParamsList = [
  'sc_o',
  'nwt_nav',
  'sc_o_PropActionOrigin',
  'signup_channel',
  'ijt',
  'dest_url',
  'sc_cdvid',
  'register_redirect_to',
  'sc_p',
];

const FALLBACK_DOMAIN = 'https://fallback-base-domain.com';

export const removeCSRParams = (url: string): string => {
  let parsedUrl;
  try {
    parsedUrl = new URL(url, FALLBACK_DOMAIN);
  } catch (error) {
    console.error('Failed to parse URL:', error);
    return url;
  }
  // Remove CSR parameters
  for (const param of CSRParamsList) {
    parsedUrl.searchParams.delete(param);
  }

  let result = parsedUrl.toString();

  // For relative URLs, remove the base URL
  if (result.startsWith(FALLBACK_DOMAIN)) {
    const prefix = url.startsWith('/')
      ? FALLBACK_DOMAIN
      : `${FALLBACK_DOMAIN}/`;
    result = result.replace(prefix, '');
  }

  // Maintain trailing slash consistency with original URL
  if (!url.endsWith('/') && result.endsWith('/') && result.length > 1) {
    result = result.slice(0, -1);
  }

  return result.replaceAll('+', '%20');
};
